import React from 'react';

export default function ContactMe() {
  return (
    <div>ContactMe</div>
  );
}
